import ProfileComponent from "../components/profile";

const ProfilePage = () => {
  return <ProfileComponent/>;
};
export default ProfilePage;